export default [
	 null, 		 '#ffffff', '#ef4848', '#edae70', '#f7f7a6', '#b5f4ab', '#a8f4f4', '#8b8fef',
	'#131313', '#ba1e1e', '#c97936', '#e8ef65', '#79ba6c', '#68bcb8', '#5661af', '#a845ad',
	'#930c0c', '#824212', '#e2d105', '#457c37', '#3e847f', '#263266', '#621868', '#ea7aed'
]
